import { useEffect, useState } from 'react';
import { useAuth } from '../../auth/hooks/useAuth';
import { subscribeToSignatureSetup } from '../services/signingService';

// Subscribes to the current user's signatureSetup field.
// Returns { setup, loading } where setup is null if the user hasn't set up yet.
export const useSignatureSetup = () => {
  const { user } = useAuth();
  const [setup, setSetup] = useState(null);
  const [loading, setLoading] = useState(!!user);

  useEffect(() => {
    if (!user?.uid) {
      setSetup(null);
      setLoading(false);
      return;
    }
    setLoading(true);
    const unsubscribe = subscribeToSignatureSetup(user.uid, (next) => {
      setSetup(next);
      setLoading(false);
    });
    return unsubscribe;
  }, [user?.uid]);

  return { setup, loading };
};
